export default {
  getQuestionAndAnswerList: "BackEnd/getQuestionAndAnswerList",
  getQuestionAndAnswerDetails: "BackEnd/getQuestionAndAnswerDetails",
  setQuestionAndAnswer: "BackEnd/setQuestionAndAnswer",
  updateQuestionAndAnswer: "BackEnd/updateQuestionAndAnswer",
  deleteQuestionAndAnswer: "BackEnd/deleteQuestionAndAnswer",
  updateQuestionAndAnswerOrders: "BackEnd/updateOrders",
};
